module.exports = __webpack_public_path__ + "img/form-studio-only-logo.6fa7ef58.svg";